// Hrvatski - hr - 克罗地亚语
const hr = {
  home: {
    home: 'Početna',
    solutions: 'Rješenja',
    support: 'Podrška',
    news: 'Vijesti',
    aboutUs: 'O nama',
    contactUs: 'Kontakt',
    cgm: 'CGM',
    download: 'Preuzimanja',
    helpCenter: 'Centar za pomoć',
    copyText: '© 2026 HIPPO MEDICAL PTE. LTD. Sva prava pridržana.',
    menu: 'Izbornik',
    quickLinks: 'Brze poveznice',
    contact: 'Kontakt',
    legal: 'Pravno',
    termsUse: 'Uvjeti korištenja',
    privacyPolicy: 'Politika privatnosti',
    portal: 'Korisnički portal',
    hClinic: 'H-Clinic',
    emailPlaceholder: 'E-pošta',
    subscribe: 'Pretplati se',
    signUp: 'Prijavite se za najnovije vijesti',
    downloadApp: 'Preuzmi aplikaciju',
    blogNews: 'Blog i vijesti',
    latestArticles: 'Najnoviji članci',
    viewAllArticles: 'Pogledaj sve članke',
    empower: 'Poboljšajte svoje zdravstveno putovanje s nama',
    empowerList1Content:
      'Hippo CGM je znatno olakšao upravljanje dijabetesom mog sina. Možemo koristiti HIPPOLINK kako bismo jasno vidjeli njegove obrasce kretanja glukoze i s povjerenjem prilagodili skrb o njemu. To nam pruža mir.',
    empowerList1Name: 'Petra N., Češka (majka djeteta s dijabetesom tip 1)',
    empowerList2Content:
      'Preporučujemo HIPPO CGM našim pacijentima zbog njegove izvanredne stabilnosti i dugotrajnog nošenja. Povratne informacije korisnika su odlične, posebno od onih koji traže povoljniju opciju.',
    empowerList2Name: 'Dr. Luca B., endokrinolog, Italija',
    empowerList3Content:
      'Nedavno sam počeo koristiti Hippo CGM — udoban je, točan, a obavijesti su mi pomogle da izbjegnem nisku razinu glukoze tijekom noći. Veoma sam zadovoljan rezultatima do sada.',
    empowerList3Name:
      'Fahad A., Saudijska Arabija (pacijent s dijabetesom tip 2)',
    reliable: 'Vaš pouzdan partner za upravljanje dijabetesom',
    hippoH1: 'HiPPO H1',
    challenges: 'Izazovi',
    constant: 'Stalno praćenje šećera u krvi',
    traditional: 'Tradicionalno ubadanje prsta može biti bolno',
    dataOverload: 'Preopterećenje podacima',
    managing: 'Upravljanje podacima o glukozi može biti složeno',
    treatment: 'Prilagodba liječenja',
    accurately: 'Točno određivanje terapije je složeno',
    lifestyle: 'Integracija u stil života',
    balancing:
      'Usklađivanje prehrane, vježbanja i lijekova može predstavljati izazov.',
    hippoCan: 'Hippo biosenzori nude',
    painless: 'Bezbolno i diskretno praćenje',
    ourCgm: 'Naš CGM omogućuje kontinuirano mjerenje',
    realTime: 'Podaci i uvidi u stvarnom vremenu',
    accessYour:
      'Pristup podacima putem pametnog telefona, što vam omogućava da pratite trendove i donosite informirane odluke.',
    personalized: 'Personalizirana podrška',
    ourCgmSys:
      'Upozorenja i podsjetnici aplikacije pomažu u održavanju usklađenosti s vašim planom liječenja',
    improved: 'Bolje donošenje odluka',
    gain: 'Dublje razumijevanje reakcija tijela  na različite događaje osnažuje vas da bolje kompenzirate fluktuacije glukoze. Korištenje povratnih informacija u stvarnom vremenu omogućava vam da preciznije prilagodite svoje dnevne aktivnosti   i ostvarite optimalne rezultate.',
    // about: 'O nama',
    companyProfile: 'Profil tvrtke',
    banner1Title: 'Dobrodošli u Hippo Medical',
    banner1Content: 'Na čelu CGM inovacija',
    get banner2Title() {
      return this.banner1Title;
    },
    banner2Content: 'Postavljamo nove standarde',
    banner3Content: '24-satna zaštita glukoze',
    get banner4Title() {
      return this.banner1Title;
    },
    banner4Content: 'Vodeći u CGM tehnologiji',
    // 错误提示
    subscribeSuccess: 'Pretplata uspješna', // ai翻译
    subscribeFailed: 'Pretplata neuspješna', // ai翻译
    invalidEmail: 'Nevažeća adresa e-pošte', // ai翻译
  },
  cgm: {
    get banner1Title() {
      return hr.home.banner1Title;
    },
    get banner1Content() {
      return hr.home.banner4Content;
    },
    whyChoose: 'Zašto odabrati HiPPO CGM',
    accurate: 'Točnost kojoj možete vjerovati',
    accurateText: 'Enzimska tehnologija treće generacije donosi',
    accurateText1: 'stabilne i točne performanse',
    easyUse: 'Jednostavno za korištenje',
    easyUseText: '14 dana kontinuiranog praćenja',
    realTime: 'Praćenje',
    realTimeText: 'Upozorenja za hipo i hiperglikemiju',
    realTimeText1: 'Dijeljenje podataka u stvarnom vremenu',
    hippo: 'HiPPO',
    hCgm: 'H1 CGM',
    keep: 'Informira vas bilo kada i bilo gdje',
    withHippo: 'S HiPPO aplikacijama i portalom',
    smallSensors: 'Mali senzori, udobno nošenje',
    agpReport:
      'Profesionalni AGP izvještaj omogućio je zdravstvenim radnicima i korisnicima da odmah zabilježe ključne informacije.',
    unlimitedFollow:
      'Neograničeno praćenje omogućava zdravstvenim radnicima da učinkovito upravljaju većim brojem korisnika.',
    iWatchApp: 'Dostupna iWatch aplikacija',
    certified: 'Certificirano za djecu',
    loremIp:
      'Sustav je klinički validiran za djecu stariju od 3 godine čime se osigurava sigurnost, točnost i udobnost za mlađe pacijente. S dokazanim senzorima visoke točnosti i nježnim, koži prijateljskim materijalima, pruža pouzdano praćenje glukoze za djecu i adolescente — podržavajući zdravstvene radnike u pružanju sigurnog, podacima vođenog dijabetološkog zbrinjavanja.',
  },
  news: {
    date: 'Datum',
    recommendedArticles: 'Preporučeni članci',
  },
  support: {
    download: 'Preuzmi vodiče',
    supportDown: 'Podrška/Preuzimanja',
  },
  about: {
    welcome: 'Dobrodošli u Hippo Medical',
    covered: 'Pokrivene zemlje',
    patents: 'Patenti',
    features: 'Značajke3',
    ring: 'Prsten',
    apparently:
      'Pametni prsten koji prati parametre poput zasićenosti krvi kisikom, srčanog ritma i sna. Što je još važnije, ima algoritamsku povezanost s našim kontinuiranim mjernim uređajem (CGM). Lansiranje u 2026. godini. Ostanite s nama!',
    cgmSky:
      'Profesionalni CGM za pacijente i liječnike, pruža visoku točnost, jednostavnu interakciju sa softverom i koristi Hippo Medical algoritme.',
    smartWatch: 'Pametni sat',
    byTheSame:
      'Nosivi uređaj za mjerenje krvnog tlaka koji može kontinuirano pratiti sistolički tlak, dijastolički tlak, srednji arterijski tlak i još mnogo toga, s algoritmom razvijenim od strane Hippo Medical. Lansiranje u 2026. godini. Ostanite s nama!',
    explore: 'Istraži',
    hippoPte: 'HIPPO MEDICAL PTE. LTD.',
    paya: '60 PAYA LEBAR ROAD',
    lebar: '#11-53',
    road: 'PAYA LEBAR SQUARE',
    singa: 'SINGAPUR (409051)',
    zipCode: 'Poštanski broj',
    emailCode: '409051',
    email: 'E-pošta',
    emailText: 'info@hippodiabetes.com',
    name: 'Ime',
    company: 'Tvrtka',
    message: 'Poruka',
    phone: 'Telefon',
    submit: 'Pošalji',
    commingSoon: 'Uskoro',
    cpInfo1:
      'Hippo Medical je globalna MedTech tvrtka sa sjedištem u Singapuru, usmjerena na revolucioniranje upravljanja kroničnim bolestima putem medicinskih nosivih biosenzora. Naša vizija je pružiti kontinuirano praćenje i naprednu analizu podataka.',
    cpInfo2:
      'Razvijanjem biosenzora nove generacije i inovativne platforme za analizu podataka, cilj nam je transformirati dijagnostiku i usmjeriti se prema proaktivnijem i personaliziranom pristupu.',
    submitFailed: 'Slanje neuspješno', // ai翻译
    get invalidEmail() {
      return hr.home.invalidEmail;
    },
    fillAllFields: 'Molimo ispunite ovo polje', // ai翻译
  },
  download: {
    language: 'Jezik',
    product: 'Proizvod',
    unit: 'Jedinica',
    fetchFailed: 'Dohvaćanje neuspješno', // ai翻译
  },
  help: {
    search: 'Pretraga',
    support: 'Podrška/Centar za pomoć/H1 CGM',
    source: 'Online resursi HiPPO H1 CGM',
    viewAll: 'Prikaži sve',
    insert: 'Kako postaviti H1 CGM',
    setUp: 'Kako postaviti H1 aplikaciju',
    faq: 'Česta pitanja H1 CGM',
    freq: 'Često postavljana pitanja',
    noData: 'Nema pronađenog sadržaja..',
    searchKeys: {
      warmUp: 'Neuspjeh faze zagrijavanja',
      waterLeakage: 'Curenje vode',
      lowGlucose: 'Niska razina glukoze',
      cannotPair: 'Ne može se povezati s pametnim telefonom',
    },
  },
  faq: {
    faq: 'FAQ',
    general: 'Opća pitanja',
    need: 'Trebate pomoć?',
    here: 'Ovo su najčešća pitanja',
    technical: 'Tehnička pitanja',
  },
  lang: {
    chooseCountry: 'Odaberite državu/regiju',
    northAmerica: 'Sjeverna Amerika', // ai翻译
    southAmerica: 'Južna Amerika', // ai翻译
    europe: 'Europa', // ai翻译
    africa: 'Afrika', // ai翻译
    asia: 'Azija', // ai翻译
    oceania: 'Oceanija', // ai翻译
    other: 'Ostalo', // ai翻译
  },
  aboutMap: {
    suzhou: {
      name: 'Suzhou, Kina',
      subName: 'Proizvodno mjesto',
      hovData:
        'Globalno sjedište R&D/centar podataka/prodaja Azija i Australija',
    },
    dubai: {
      name: 'Dubai',
      subName: 'Regionalni ured',
      hovData: 'Prodajni tim JI Azije',
    },
    singapore: {
      name: 'Singapur',
      subName: 'Sjedište',
      hovData: 'Prodajni tim JI Azije',
    },
    sanFrancisco: {
      name: 'San Francisco, SAD',
      subName: 'Regionalni ured',
      hovData: 'Prodajni tim Sjeverna Amerika',
    },
    barcelona: {
      name: 'Barcelona',
      subName: 'Prodajni ured',
      hovData:
        'Globalno sjedište R&D/centar podataka/prodaja Azija i Australija',
    },
  },
};
export default hr;
